const TrashIcon = ({ height = "16" }) => {
  return (
    <svg
      height={height}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3954 3.47318C13.357 3.36997 12.3185 3.29257 11.2736 3.23452V3.22807L11.1317 2.38955C11.0349 1.79613 10.893 0.906006 9.38366 0.906006H7.69371C6.19082 0.906006 6.04892 1.75743 5.94571 2.3831L5.81026 3.20872C5.21039 3.24742 4.61053 3.28612 4.01066 3.34417L2.69482 3.47318C2.42392 3.49898 2.23041 3.73763 2.25621 4.00209C2.28201 4.26655 2.51422 4.46005 2.78513 4.43425L4.10096 4.30525C7.48085 3.96984 10.8865 4.09884 14.3051 4.4407C14.3245 4.4407 14.3374 4.4407 14.3567 4.4407C14.6018 4.4407 14.8147 4.25365 14.8405 4.00209C14.8599 3.73763 14.6663 3.49898 14.3954 3.47318Z"
        fill="#7E858F"
      />
      <path
        d="M13.2097 5.35068C13.0549 5.18942 12.842 5.09912 12.6227 5.09912H4.46968C4.25038 5.09912 4.03107 5.18942 3.88272 5.35068C3.73436 5.51193 3.65051 5.73124 3.66341 5.95699L4.06332 12.5749C4.13427 13.5553 4.22457 14.7808 6.47569 14.7808H10.6167C12.8678 14.7808 12.9581 13.5617 13.0291 12.5749L13.429 5.96344C13.4419 5.73124 13.358 5.51193 13.2097 5.35068Z"
        fill="#7E858F"
      />
    </svg>
  );
};

export default TrashIcon;
